module.exports = __webpack_public_path__ + "static/media/spada-trader-banner-2.25f44a7e.jpg";